import {
  type Subscription,
  type SubscriptionResponse,
  MembershipPlanType,
} from '@/features/account/services/MembershipPlan/types'
import { type User } from '@/features/account/services/User/types'

export const subscriptionForUser = (userId: number | string) =>
  `/v1/customers/${userId}/subscriptions`

export const toMembershipPlan = (subscription?: SubscriptionResponse | null): Subscription => {
  return {
    id: subscription?.plan?.id ?? '',
    name: subscription?.plan?.name ?? '',
    price: (subscription?.plan?.amount ?? 0) / 100,
    startDate: epochSecondsToISO(subscription?.start),
    renewalDate: epochSecondsToISO(subscription?.current_period_end),
    trialStart: epochSecondsToISO(subscription?.trial_start),
    trialEnd: epochSecondsToISO(subscription?.trial_end),
    cancelAtPeriodEnd: subscription?.cancel_at_period_end ?? false,
    interval: subscription?.plan?.interval ?? '',
    intervalCount: subscription?.plan?.interval_count ?? 0,
    refundable: subscription?.refundable ?? false,
    status: subscription?.status || '',
    type: subscription?.type ?? '',
  }
}

export const epochSecondsToISO = (time?: number | null) => {
  try {
    return time ? new Date(time * 1000).toISOString() : ''
  } catch {
    return ''
  }
}

export const getIsMember = (user: User, membership: Subscription) => {
  return Boolean(
    (user.exempt && membership.type !== MembershipPlanType.CIRCLE_360) || membership.id,
  )
}
